/* eslint-disable max-len */
import React, { useContext } from 'react';
import CustomOverLay from '../../../components/CustomOverLay';
import GlobalContext from '../../../components/Context/GloablContext';
import { useSelector } from 'react-redux'
import { convertEpochToDateFormat } from '../../../CommonMethods/DateConversion';
import { dataService } from '../../../services/data.services';
import { useGetImportListQuery } from '../../../features/importSlice';

export default function ImportHistoryTable({userId}) {
    const { setToastmessage, setToastErrorMessage, isSideBar } = useContext(GlobalContext);

    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const {data,error,isFetching,status } = useGetImportListQuery(`access=all&user_id=${userId}`);
    

    const handleDownload = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const filename = url.split('/').pop().split('?')[0];
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;  // Use the extracted filename
            link.target = '_blank';  // Open the download in a new tab
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            // Show success message
            setToastmessage('Import history downloaded successfully');
        } catch (error) {
            // Show error message
            setToastErrorMessage('Failed to download file.');
        }
    };

    const  DownoadExportCaputreApi= async (type,fileName) => {
        try {
            const response = await dataService.PostAPI('',`users/activity-logs?action=result-file&user_type=${type}&filename=${fileName}`)
        } catch (error) {
            console.error('error', error);
        }
    };

    return (
        <>
            {<>
                <div className='border my-[32px] border-[#EDD7E1] rounded-lg pb-2'>
                    <div className='relative flex border-b border-[#EDD7E1] justify-between items-center py-3.5 pr-4 pl-[18px]'>
                        <p className='text-base font-semibold text-[#972E4C]'>Import History</p>
                    </div>
                    <div className='overflow-auto scrollbar_purple pb-2.5'>
                        { ((isFetching&&status!==""&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Import List..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-full ${isSideBar?'w-full h-[calc(100vh-700px)]':'w-full h-[calc(100vh-700px)]'}`}/>: <>
                            <table aria-label="Outside Table" className="w-full table-auto">
                                <thead>
                                    <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm z-[1] sticky top-0 left-0">
                                        <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm min-w-[200px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                Timestamp
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                File Name
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[150px] rounded-tl-sm rounded-bl-sm">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                Type
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                Result
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                                Action
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                {/* tbody */}
                                
                                {error?.status !== 404 ? (
                                    <tbody>
                                        {data.map((item, index) => (
                                            
                                            <tr key={index} className="hover:bg-[#F8EEF1]">
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {convertEpochToDateFormat(item?.updated_at, dateformat)}
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {item?.uploadedFile}
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {item?.type
                                                        .split('-')
                                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                        .join(' ')}

                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {item?.status}
                                                </td>
                                                <td className="pr-[18px] pl-[30px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {item?.presignedUrl === '' ? '-' : (
                                                        <img
                                                            data-testid={`download-history-${index}`}
                                                            src="/images/download-red.svg"
                                                            alt="download-icon"
                                                            onClick={() => {handleDownload(item?.presignedUrl),DownoadExportCaputreApi(item?.type,item?.uploadedFile)}}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                        
                                        
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr>
                                            <td colSpan="5" className="px-[18px] h-[100px] py-2 text-sm text-center font-normal text-[#031624]">
                                                Import history not found
                                            </td>
                                        </tr>
                                    </tbody>
                                )}
                            
                            </table>


                        </>}
                    </div>
                
                </div>
            </>}
        </>
    )
}
